import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Box } from '@mui/material';

import { useAuthStore } from '@core/features/auth';

import Image from '/bg2.jpg';

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ params, location }) => {
    // The magic link route must always be allowed to run its token
    // exchange: a (possibly stale/expired) persisted session would
    // otherwise bounce the user away before the link is redeemed,
    // leaving them in a logged-out loop.
    if (location.pathname.startsWith('/auth/token/')) {
      return;
    }

    const accessToken = useAuthStore.getState().accessToken;

    if (accessToken) {
      // If user is already logged in, redirect to the venue dashboard
      // or homepage if no venue in URL
      const venueSlug = (params as { venueSlug?: string }).venueSlug;
      if (venueSlug) {
        throw redirect({
          to: '/$venueSlug',
          params: { venueSlug },
        });
      }
      throw redirect({
        to: '/',
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Box
      sx={{
        height: '1000px',
        backgroundColor: 'primary.light',
        backgroundImage: `url(${Image})`,
        backgroundSize: 'cover',
      }}
    >
      <Outlet />
    </Box>
  );
}
